import React, { useState } from "react";
import { HomePageExplore } from "../../../data/homepage-explore";
import HighlightText from "./HighlightText";
import CourseCard from "./CourseCard";

const tabsName = [
  "Free",
  "New to coding",
  "Most popular",
  "Skills paths",
  "Career paths",
];

const ExploreMore = () => {
  const [currentTab, setCurrentTab] = useState(HomePageExplore[0].tag);
  const [courses, setCourses] = useState(HomePageExplore[0].courses);
  const [currentCard, setCurrentCard] = useState(
    HomePageExplore[0].courses[0].heading
  );

  // function to update the `current tab`, `courses`, `active current card`
  const setMyCards = (value) => {
    setCurrentTab(value);
    const result = HomePageExplore.filter((item) => item.tag === value);
    setCourses(result[0].courses);
    setCurrentCard(result[0].courses[0].heading);
  };
  return (
    <div className="">
      {/* heading */}
      <div className="text-4xl font-semibold text-center">
        Unlock the
        <HighlightText text={"Power of Code"} />
      </div>
      {/* subheading */}
      <p className="text-center text-richblack-300  text-lg font-semibold mt-3 mb-3 lg:mb-0 capitalize">
        Learn to build anything you can Imagine
      </p>

      {/* tabs */}
      <div className="hidden lg:flex mt-5 drop-shadow-[0_1.5px_rgba(255,255,255,0.25)] flex-row rounded-full bg-richblack-800 mb-5 border-richblack-100 p-1 hover:drop-shadow-none gap-3">
        {tabsName.map((element, index) => {
          return (
            <div
              className={`text-[16px] flex flex-row items-center gap-9 font-medium 
              ${
                currentTab === element
                  ? "bg-richblack-900 text-richblack-5 font-medium"
                  : "text-richblack-200"
              } rounded-full transition-all duration-200 cursor-pointer
              hover:bg-richblack-900 hover:text-richblack-5 px-8 py-2`}
              key={index}
              onClick={() => {
                setMyCards(element);
              }}
            >
              {element}
            </div>
          );
        })}
      </div>
      {/* gap div */}
      <div className="hidden lg:block lg:h-[200px]"></div>
      {/* course cards */}
      <div className="lg:absolute gap-10 justify-center lg:gap-0 flex lg:justify-between flex-wrap w-full lg:left-1 lg:-translate-y-[50%] text-black lg:mb-0  mb-9 lg:px-0 px-3">
        {courses.map((element, index) => {
          return (
            <CourseCard
              key={index}
              cardData={element}
              currentCard={currentCard}
              setCurrentCard={setCurrentCard}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExploreMore;
